import { Drawer } from 'antd';
import BoxContainer from '../BoxContainer';
import FilterContainer from '../FilterContainer';
import Title from '../BoxContainer/components/Title';
import DynamicForm from './DynamicForm';
import { useIntl } from 'react-intl';

export const FormsDrawer = ({ open, onClose, dataSource }) => {
  const intl = useIntl();
  return (
    <Drawer open={open} onClose={onClose} closable={false} footer={null} destroyOnClose>
      <BoxContainer>
        <BoxContainer content bottomBorder fixed>
          <FilterContainer
            goBack={onClose}
            title={<Title.Header value={intl.formatMessage({ id: 'forms.title' })} />}
          />
        </BoxContainer>
        <BoxContainer content>
          <DynamicForm.Display forms={dataSource || []} />
        </BoxContainer>
      </BoxContainer>
    </Drawer>
  );
};
